export default {
  data() {
    return {
      inputType: 'textarea',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
